// 基础大小，通常是设计稿的宽度
const baseSize = 750;

// 设置rem函数
function setRem() {
  // 获取当前窗口的宽度
  const docEl = document.documentElement;
  // const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  const clientWidth = docEl.clientWidth || document.body.clientWidth;
  // 设置根元素字体大小
  docEl.style.fontSize = (clientWidth / baseSize) * 100 + 'px';
}

// 初始化设置
setRem();

// 监听窗口变化
window.addEventListener('resize', setRem);
window.addEventListener('pageshow', function (e) {
  if (e.persisted) {
    setRem();
  }
});